/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import List from "@mui/material/List";
import { styled } from "@mui/material/styles";
import clsx from "clsx";
import { useDispatch } from "react-redux";
import BASENavItem from "../BASENavItem";

const StyledList = styled(List)(({ theme }) => ({
  "& .base-list-item": {
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? "rgba(255, 255, 255, 0.05)"
          : "rgba(0,0,0,.04)",
    },
    "&:focus:not(.active)": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? "rgba(255, 255, 255, 0.06)"
          : "rgba(0,0,0,.05)",
    },
  },
  "& .base-list-item-text": {
    margin: 0,
  },
  "& .base-list-item-text-primary": {
    lineHeight: "20px",
  },
  "&.active-square-list": {
    "& .base-list-item, & .active.base-list-item": {
      width: "100%",
      borderRadius: "0",
    },
  },
  "&.dense": {
    "& .base-list-item": {
      paddingTop: 0,
      paddingBottom: 0,
      height: 32,
    },
  },
}));

function BASENavVerticalLayout(props) {
  const { navigation, layout, active, dense, className, onItemClick } = props;
  const dispatch = useDispatch();

  const handleItemClick = (item) => {
    onItemClick?.(item);
  };

  return (
    <StyledList
      className={clsx(
        "navigation whitespace-nowrap px-12 py-0",
        `active-${active}-list`,
        dense && "dense",
        className
      )}
    >
      {navigation.map((_item) => (
        <BASENavItem
          key={_item.id}
          type={`vertical-${_item.type}`}
          item={_item}
          nestedLevel={0}
          onItemClick={handleItemClick}
        />
      ))}
    </StyledList>
  );
}

export default BASENavVerticalLayout;
